import { render, staticRenderFns } from "./PlatformManage.vue?vue&type=template&id=ca24df7a&scoped=true&"
import script from "./PlatformManage.vue?vue&type=script&lang=js&"
export * from "./PlatformManage.vue?vue&type=script&lang=js&"
import style0 from "./PlatformManage.vue?vue&type=style&index=0&id=ca24df7a&prod&lang=scss&scoped=true&"
import style1 from "./PlatformManage.vue?vue&type=style&index=1&id=ca24df7a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca24df7a",
  null
  
)

export default component.exports